import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import { RateLimitingContext } from './Context';

type Props = {
  children: React.ReactNode;
};

export const RateLimitingContainer = (props: Props) => {
  const api = useChatApiClient();

  const query = useQuery({
    queryKey: ['get:users/rate-limiting'],
    queryFn: () => api.users.getRateLimiting(),
  });

  return (
    <RateLimitingContext.Provider value={{ query }}>
      {props.children}
    </RateLimitingContext.Provider>
  );
};

RateLimitingContainer.displayName = 'RateLimiting.Container';